package com.havn.app.features.openhouses.domain

interface OpenHouseRepository {
    suspend fun ensureAgentProfile(agentId: String, email: String?): Result<Unit>
    suspend fun propertyOptions(agentId: String, agencyId: String? = null): Result<List<OpenHousePropertyOption>>
    suspend fun openHousesForAgent(agentId: String, agencyId: String? = null): Result<List<OpenHouse>>
    suspend fun openHousePage(agentId: String, agencyId: String? = null, query: String = "", offset: Int = 0, limit: Int = 20): Result<List<OpenHouse>>
    suspend fun openHousesForProperty(agentId: String, propertyId: String): Result<List<OpenHouse>>
    suspend fun openHouseDetail(agentId: String, openHouseId: String): Result<OpenHouse>
    suspend fun scheduleOpenHouse(agentId: String, draft: OpenHouseDraft, agencyId: String? = null): Result<OpenHouse>
    suspend fun updateOpenHouse(agentId: String, openHouseId: String, draft: OpenHouseDraft): Result<OpenHouse>
    suspend fun deleteOpenHouse(agentId: String, openHouseId: String): Result<Unit>
    suspend fun startOpenHouse(agentId: String, openHouseId: String): Result<OpenHouse>
    suspend fun endOpenHouse(agentId: String, openHouseId: String): Result<OpenHouse>
    suspend fun submitVisitorSignIn(
        agentId: String,
        openHouseId: String,
        draft: VisitorSignInDraft
    ): Result<OpenHouse>
    suspend fun checkInClientQr(
        agentId: String,
        openHouseId: String,
        qrPayload: String
    ): Result<OpenHouse>
    suspend fun removeClientFromOpenHouse(
        agentId: String,
        openHouseId: String,
        clientId: String
    ): Result<OpenHouse>
}
